import {CLEAR_ERRORS} from "../actionTypes/types";

export const clearErrors = () => {
    // console.log('CLEARING');
    return {
        type: CLEAR_ERRORS
    }
};
